import type { FreightMatching } from "@x-mile/api-contract";
import type { DeepPartial } from "react-hook-form";
import type { CreateDeliveryProposalFormSchemaType } from "./model/validation";

// OfferCargoの構造とUIの構造が異なるため変換する必要がある
export const calculateDeliveryProposalInputValues = (
  offerCargo: FreightMatching.schemas.OfferCargo,
): DeepPartial<CreateDeliveryProposalFormSchemaType> => {
  const firstDestination = offerCargo.destinations[0];
  const loadingDestination = firstDestination
    ? {
        deadlineDate: offerCargo.loadingOn,
        deadlineType: firstDestination.deadlineType ?? undefined,
        deadlineTime: firstDestination.deadlineTime ?? undefined,
        deadlineTimeEnd: firstDestination.deadlineTimeEnd ?? undefined,
      }
    : undefined;
  const transitDestinations = offerCargo.destinations
    .slice(1, -1)
    .map((transitDestination) => {
      return {
        deadlineDate: undefined,
        deadlineType: transitDestination.deadlineType ?? undefined,
        deadlineTime: transitDestination.deadlineTime ?? undefined,
        deadlineTimeEnd: transitDestination.deadlineTimeEnd ?? undefined,
      };
    });
  const lastDestination =
    offerCargo.destinations[offerCargo.destinations.length - 1];
  const unloadingDestination = lastDestination
    ? {
        deadlineDate: offerCargo.unloadingOn,
        deadlineType: lastDestination.deadlineType ?? undefined,
        deadlineTime: lastDestination.deadlineTime ?? undefined,
        deadlineTimeEnd: lastDestination.deadlineTimeEnd ?? undefined,
      }
    : undefined;
  return {
    loadingDestination,
    transitDestinations,
    unloadingDestination,
    shippingFee: offerCargo.shippingFee ?? undefined,
    vehicleId: offerCargo.vehicle?.id ?? undefined,
  };
};
